import { Avatar, Badge } from '@mui/material'

import { AccountConnectionIndicator } from 'src/components/step-accounts-connection/association/account-connection-indicator.component'
import { AccountConnectionWrapper } from 'src/components/step-accounts-connection/association/account-connection-wrapper.component'
import { IStepAccountsBaseWithId } from 'src/types'

interface IProps {
  connection: Pick<IStepAccountsBaseWithId, 'account_approved' | 'account'>
  large?: boolean
}

export const StepIconBadge = ({ connection, large }: IProps) => {
  return (
    <AccountConnectionWrapper
      title={connection.account?.account_holder}
      approvedConnection={connection.account_approved}
    >
      <Badge
        overlap="circular"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        badgeContent={
          <AccountConnectionIndicator
            disableTooltip
            approvedConnection={connection.account_approved}
          />
        }
      >
        <Avatar
          sx={{ width: large ? 26 : 20, height: large ? 26 : 20 }}
          alt={connection?.account?.account_holder}
          src={connection.account?.image_small || connection.account?.image}
        />
      </Badge>
    </AccountConnectionWrapper>
  )
}
